import { BulletPoint } from "@lending/components/BulletPoint/BulletPoint";
import { useMembershipShareProduct } from "../../Activate/hooks/useMembershipShareProduct";
import styles from "../Select.module.css";

interface NewMembershipOptionProps {
  selected: boolean;
  label: string;
  onSelectOption: () => void;
}

function NewMembershipOption({ selected, label, onSelectOption }: NewMembershipOptionProps) {
  const { membershipShareProduct } = useMembershipShareProduct();
  const membershipShareProductDetails = membershipShareProduct?.details ?? [];

  return (
    <button
      type="button"
      className={`${styles.optionCard} ${selected ? styles.optionCardSelected : ""}`}
      aria-pressed={selected}
      onClick={onSelectOption}
    >
      <div className={styles.optionCardContent}>
        <div className={styles.optionBody}>
          <div className={`${styles.optionIcon} ${selected ? styles.optionIconSelected : ""}`}>
            <span className="narmi-icon-plus fontSize--l" />
          </div>

          <div className={styles.optionMain}>
            <div className={styles.optionLabel}>{label}</div>

            {selected && membershipShareProduct ? (
              <div className={styles.membershipDetailsCard}>
                <div className={styles.membershipProductContent}>
                  <div className={styles.membershipProductName}>{membershipShareProduct.name}</div>

                  {membershipShareProductDetails.length ? (
                    <div className={styles.membershipProductDetails}>
                      {membershipShareProductDetails.map((detail) => (
                        <BulletPoint key={detail} text={detail} className="fontSize--s" />
                      ))}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </button>
  );
}

export { NewMembershipOption };
